import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=4320a0b8"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports